(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../modules/data/channels.js'),
            require('../enums/colors.js'),
            require('../enums/metrics.js'),
            require('../strings/strings.js'),
            require('../modules/utils/metric.js'),
            require('../modules/data/linkedInJobFunctions.js'),
            require('lodash')
        );

    } else {
        RivalIQ.metrics.definitions.linkedin = exportFn(
            RivalIQ.data.channels,
            RivalIQ.enums.colors,
            RivalIQ.enums,
            RivalIQ.strings,
            RivalIQ.utils.metric,
            RivalIQ.data.LinkedInJobFunctionMap,
            window._
        );
    }

    function exportFn(channels, colors, metricEnums, strings, utils, liJobFunctions, _) {

        const channel = channels.get('linkedin');

        function findLiJob(job) {
            return _.find(liJobFunctions, function (obj) {
                return obj.code === job || (obj.code === '' && job === 'none');
            });
        }

        function valueByDimension(dimension, a, b) {
            return function (val, metric) {
                if (_.includes(metric.dimensions, dimension)) {
                    return a;
                }
                return b;
            };
        }

        return {
            className: channel.get('channel'),
            format: channel.get('name'),
            name: channel.get('name'),
            presence_reach: {
                name: function (val, metric) {
                    const job = metric.job_function;
                    if (job) {
                        const def = findLiJob(job);
                        let name = def.description;
                        if (def.key === 'none') {
                            name = 'Unknown function';
                        }
                        return `Followers, ${name}`;
                    }

                    return 'Followers';
                },
                description: function (val, metric) {
                    const job = metric.job_function;
                    if (job) {
                        const def = findLiJob(job);
                        let name = def.description;
                        if (def.key === 'none') {
                            name = 'Unknown';
                        }
                        return `The number of followers with ${name} job functions this company has.`;
                    }

                    if (_.includes(metric.dimensions, 'post')) {
                        return strings.linked_in_post_presence_reach_description;
                    } else {
                        return strings.linked_in_presence_reach_description;
                    }
                },
                collection: valueByDimension('post', metricEnums.collection.GENERAL, metricEnums.collection.AUDIENCE),
                noHistoricData: true
            },
            presence_reach_adds: {
                metricType: metricEnums.metricType.VOLUME,
                collection: metricEnums.collection.AUDIENCE,
                noHistoricData: true
            },
            unique_post_visitors: {
                name: 'Presence Update Reach / Day',
                description: strings.linked_in_unique_post_visitors_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                metricType: metricEnums.metricType.VOLUME,
                collection: metricEnums.collection.REACH,
                summable: false
            },
            followers_per_linkedin: {
                name: 'Followers, Total (from LinkedIn)',
                collection: metricEnums.collection.AUDIENCE,
                metricType: metricEnums.metricType.TOTAL,
                deprecationReason: 'Replaced by Followers',
                noHistoricData: true
            },
            post_impressions: {
                name: 'Presence Update Impressions',
                description: strings.linked_in_presence_post_impressions_description,
                collection: metricEnums.collection.IMPRESSIONS,
                enoughDataKey: 'statistics'
            },
            post_impressions_per_day: {
                name: 'Presence Update Impressions / Day',
                description: strings.linked_in_post_impressions_per_day_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                collection: metricEnums.collection.IMPRESSIONS,
                type: metricEnums.dataType.NUMERIC,
                enoughDataKey: 'statistics',
                summable: false
            },
            job_function: {
                presence_reach: {
                    collection: metricEnums.collection.AUDIENCE,
                    enoughDataKey: 'statistics'
                }
            },
            impression_type: {
                value: {
                    organic: {
                        presence_reach_adds: {
                            name: 'Follower Adds, Organic',
                            description: strings.linked_in_presence_reach_adds_organic_description
                        }
                    },
                    paid: {
                        presence_reach_adds: {
                            name: 'Follower Adds, Paid',
                            description: strings.linked_in_presence_reach_adds_paid_description
                        }
                    }
                }
            },
            page_engagement_rate: {
                name: 'Presence Update Engagement Rate by Impression',
                description: strings.linked_in_engagement_rate_description,
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                collection: metricEnums.collection.ENGAGEMENT,
                enoughDataKey: 'statistics'
            },
            engagement_rate_by_impression: {
                name: 'Engagement Rate by Impression',
                description: valueByDimension('post', strings.linked_in_post_engagement_rate_by_impression_description, strings.linked_in_engagement_rate_by_impression_description),
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                collection: metricEnums.collection.ENGAGEMENT
            },
            engagement_rate_by_presence_reach: {
                name: 'Engagement Rate by Follower',
                description: valueByDimension('post', strings.linked_in_post_engagement_rate_by_presence_reach_description, strings.linked_in_engagement_rate_by_presence_reach_description),
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                collection: metricEnums.collection.ENGAGEMENT
            },
            social_engagement_rate_by_impression: {
                name: 'Social Engagement Rate by Impression',
                description: valueByDimension('post', strings.linked_in_post_social_engagement_rate_by_impression_description, strings.linked_in_social_engagement_rate_by_impression_description),
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                collection: metricEnums.collection.ENGAGEMENT
            },
            social_engagement_rate_by_presence_reach: {
                name: 'Social Engagement Rate by Follower',
                description: valueByDimension('post', strings.linked_in_post_social_engagement_rate_by_presence_reach_description, strings.linked_in_social_engagement_rate_by_presence_reach_description),
                type: metricEnums.dataType.ABSOLUTE_PERCENT,
                collection: metricEnums.collection.ENGAGEMENT
            },
            engagement_total: {
                name: 'Engagement Total',
                description: function (val, metric) {
                    if (_.includes(metric.dimensions, 'post')) {
                        // single post metric
                        return strings.linked_in_post_engagement_total_description;
                    } else {
                        // profile or post aggregate metric
                        return strings.linked_in_engagement_total_description;
                    }
                },
                collection: metricEnums.collection.ENGAGEMENT
            },
            page_engagement_total: {
                name: 'Presence Update Engagement Total',
                description: strings.linked_in_engagement_total_description,
                collection: metricEnums.collection.ENGAGEMENT,
                type: metricEnums.dataType.INTEGER,
                enoughDataKey: 'statistics'
            },
            social_engagement_total: {
                name: 'Social Engagement Total',
                description: function (val, metric) {
                    if (utils.useDetailsDescription(metric)) {
                        return strings.linked_in_post_social_engagement_total_description;
                    } else {
                        return strings.linked_in_social_engagement_total_description;
                    }
                },
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.LINKEDIN
            },
            social_engagement_total_per_post: {
                name: 'Social Engagement Total / Update',
                description: strings.linked_in_social_engagement_total_per_post_description,
                collection: metricEnums.collection.ENGAGEMENT,
                source: metricEnums.sources.LINKEDIN,
                summable: false
            },
            engagement_type: {
                // This defines the order these will appear in bar charts.
                dimensionValues: _.constant(['applause', 'conversation', 'amplification', 'action']),

                value: {
                    applause: {
                        format: utils.formatDimensionFn('Likes'),
                        className: 'x-linked-in',

                        engagement_total: {
                            name: 'Likes',
                            description: strings.linked_in_applause_by_published_date_description,
                            type: metricEnums.dataType.INTEGER,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS
                        },
                        engagement_total_per_post: {
                            name: 'Likes / Update',
                            description: strings.linked_in_applause_per_post_by_published_date_description,
                            type: metricEnums.dataType.NUMERIC,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                            summable: false
                        },
                        page_engagement_total: {
                            name: 'Presence Likes',
                            description: strings.linked_in_applause_description,
                            type: metricEnums.dataType.INTEGER,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                            enoughDataKey: 'statistics'
                        }
                    },
                    amplification: {
                        format: utils.formatDimensionFn('Updates'),
                        className: 'x-linked-in-secondary',

                        engagement_total: {
                            name: 'Shares',
                            description: strings.linked_in_amplification_by_published_date_description,
                            type: metricEnums.dataType.INTEGER,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS
                        },
                        engagement_total_per_post: {
                            name: 'Shares / Update',
                            description: strings.linked_in_amplification_per_post_by_published_date_description,
                            type: metricEnums.dataType.NUMERIC,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                            summable: false
                        },
                        page_engagement_total: {
                            name: 'Presence Shares',
                            description: strings.linked_in_amplification_description,
                            type: metricEnums.dataType.INTEGER,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                            enoughDataKey: 'statistics'
                        }
                    },
                    conversation: {
                        format: utils.formatDimensionFn('Updates'),
                        className: 'x-linked-in-tertiary',
                        engagement_total: {
                            name: 'Comments',
                            description: strings.linked_in_conversation_by_published_date_description,
                            type: metricEnums.dataType.INTEGER,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS
                        },
                        engagement_total_per_post: {
                            name: 'Comments / Update',
                            description: strings.linked_in_conversation_per_post_by_published_date_description,
                            type: metricEnums.dataType.NUMERIC,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                            summable: false
                        },
                        page_engagement_total: {
                            name: 'Presence Comments',
                            description: strings.linked_in_conversation_description,
                            type: metricEnums.dataType.INTEGER,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                            enoughDataKey: 'statistics'
                        }
                    },
                    action: {
                        format: utils.formatDimensionFn('Clicks'),
                        className: 'x-linked-in',

                        engagement_total: {
                            name: 'Clicks',
                            description: strings.linked_in_action_by_published_date_description,
                            type: metricEnums.dataType.INTEGER,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS
                        },
                        engagement_total_per_post: {
                            name: 'Clicks / Update',
                            description: strings.linked_in_action_per_post_by_published_date_description,
                            type: metricEnums.dataType.NUMERIC,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                            summable: false
                        },
                        page_engagement_total: {
                            name: 'Presence Clicks',
                            description: strings.linked_in_action_description,
                            type: metricEnums.dataType.INTEGER,
                            collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                            enoughDataKey: 'statistics'
                        }
                    }
                }
            },
            count: {
                name: 'Updates',
                description: strings.linked_in_count_description,
                collection: metricEnums.collection.ACTIVITY
            },
            posts_per_day: {
                name: 'Updates / Day',
                description: strings.linked_in_posts_per_day_description,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                collection: metricEnums.collection.ACTIVITY,
                summable: false
            },
            posts_per_week: {
                name: 'Updates / Week',
                description: strings.linked_in_posts_per_week_description,
                collection: metricEnums.collection.ACTIVITY,
                summable: false
            },
            media_type: {
                name: 'Post Type',
                type: metricEnums.dataType.STRING,
                description: strings.linked_in_post_media_type_description
            },
            likes: {
                type: metricEnums.dataType.INTEGER,
                description: valueByDimension('post', strings.linked_in_post_likes_description, strings.linked_in_post_total_likes_description),
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            comments: {
                type: metricEnums.dataType.INTEGER,
                description: valueByDimension('post', strings.linked_in_post_comments_description, strings.linked_in_post_total_comments_description),
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            clicks: {
                type: metricEnums.dataType.INTEGER,
                description: valueByDimension('post', strings.linked_in_post_clicks_description, strings.linked_in_post_total_clicks_description),
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            shares: {
                type: metricEnums.dataType.INTEGER,
                description: valueByDimension('post', strings.linked_in_post_shares_description, strings.linked_in_post_total_shares_description),
                collection: metricEnums.collection.ENGAGEMENT_DETAILS
            },
            impressions: {
                name: valueByDimension('post', 'Impressions', 'Update Impressions'),
                type: metricEnums.dataType.INTEGER,
                description: valueByDimension('post', strings.linked_in_post_impressions_description, strings.linked_in_impressions_description),
                collection: metricEnums.collection.IMPRESSIONS
            },
            impressions_per_post: {
                name: 'Impressions / Update',
                type: metricEnums.dataType.NUMERIC,
                description: strings.linked_in_impressions_per_post_description,
                collection: metricEnums.collection.IMPRESSIONS,
                summable: false
            },
            video_views: {
                name: 'Video Views',
                type: metricEnums.dataType.INTEGER,
                description: valueByDimension('post', strings.linked_in_post_video_views_description, strings.linked_in_video_views_description),
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS
            },
            video_viewers: {
                name: 'Video Viewers',
                type: metricEnums.dataType.INTEGER,
                description: strings.linked_in_post_video_viewers_description,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS
            },
            video_watched_minutes: {
                name: 'Minutes Watched',
                type: metricEnums.dataType.NUMERIC,
                description: valueByDimension('post', strings.linked_in_post_video_watched_minutes_description, strings.linked_in_video_watched_minutes_description),
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS
            },
            video_watched_minutes_per_post: {
                name: 'Minutes Watched / Update',
                type: metricEnums.dataType.NUMERIC,
                description: strings.linked_in_video_watched_minutes_per_post_description,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                summable: false
            },
            engagement_total_per_post: {
                name: 'Engagement Total / Update',
                description: strings.linked_in_engagement_total_per_post_description,
                summable: false
            },
            likes_per_post: {
                name: 'Likes / Update',
                description: strings.linked_in_likes_per_post_description,
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                summable: false
            },
            comments_per_post: {
                name: 'Comments / Update',
                description: strings.linked_in_comments_per_post_description,
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                summable: false
            },
            shares_per_post: {
                name: 'Shares / Update',
                description: strings.linked_in_shares_per_post_description,
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                summable: false
            },
            clicks_per_post: {
                name: 'Clicks / Update',
                description: strings.linked_in_clicks_per_post_description,
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.ENGAGEMENT_DETAILS,
                summable: false
            },
            video_views_per_post: {
                name: 'Video Views / Update',
                description: strings.linked_in_video_views_per_post_description,
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                summable: false
            },
            video_viewers_per_post: {
                name: 'Video Viewers / Update',
                description: strings.linked_in_video_viewers_per_post_description,
                type: metricEnums.dataType.NUMERIC,
                collection: metricEnums.collection.VIDEO_VIEWS_DETAILS,
                summable: false
            },
            overview_page_views: {
                name: 'Page Views',
                description: strings.linked_in_overview_page_views_description,
                type: metricEnums.dataType.INTEGER,
                collection: metricEnums.collection.IMPRESSIONS,
                enoughDataKey: 'statistics'
            },
            overview_page_unique_views: {
                name: 'Page Views / Day, Unique',
                description: strings.linked_in_overview_page_unique_views_description,
                type: metricEnums.dataType.NUMERIC,
                metricValueType: metricEnums.metricValueType.AVERAGE,
                collection: metricEnums.collection.IMPRESSIONS,
                enoughDataKey: 'statistics',
                summable: false
            }
        };
    }
})();
